// Random slug instead of "/admin" so the URL itself isn't guessable - see
// backend/app/api/v1/endpoints/admin.py, which mounts its router at the
// same slug. Keep these two in sync if the slug ever changes.
export const ADMIN_BASE_PATH = 'a4d98229c424af52';
export const ADMIN_TOKEN_KEY = 'zg_admin_token';

export class AdminAuthError extends Error {}

// Wraps fetch with the bearer token and a consistent base path. Throws
// AdminAuthError on a 401 (also clearing the stored token) so callers can
// redirect back to the login route in one place instead of repeating that
// check after every request.
export async function adminFetch(path, options = {}) {
  const token = sessionStorage.getItem(ADMIN_TOKEN_KEY);
  const res = await fetch(`/api/${ADMIN_BASE_PATH}${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(options.headers || {}),
      Authorization: `Bearer ${token}`,
    },
  });

  if (res.status === 401) {
    sessionStorage.removeItem(ADMIN_TOKEN_KEY);
    throw new AdminAuthError('Not authenticated');
  }

  return res;
}
